export default [
  {
    location:'Santa Marta, Colombia',
    top     :'59%',
    left    :'28.5%',
  },
  {
    location:'Nezahualcóyotl, Mexico',
    top     :'50%',
    left    :'18.5%',
  },
  {
    location:'Los Angeles, California',
    top     :'44%',
    left    :'14.5%',
  },
  {
    location:'San Francisco, California',
    top     :'40.5%',
    left    :'13%',
  },
  {
    location:'Providence, Rhode Island',
    top     :'39%',
    left    :'27.5%',
  },
  {
    location:'Santiago, Chile',
    top     :'85%',
    left    :'27.5%',
  },
  {
    location:'Nairobi, Kenya',
    top     :'64%',
    left    :'58%',
  },
  {
    location:'Bangkok, Thailand',
    top     :'55%',
    left    :'76.5%',
  },
  {
    location:'Spokane, Washington',
    top     :'35%',
    left    :'15%',
  },
  {
    location:'Cebu, Philippines',
    top     :'57%',
    left    :'82.5%',
  },
  {
    location:'Iasi, Romania',
    top     :'35.5%',
    left    :'55%',
  },
  {
    location:'Oyo, Nigeria',
    top     :'61%',
    left    :'50.5%',
  },
  {
    location:'Garugram, Haryana, India',
    top     :'51%',
    left    :'69%',
  },
  {
    location:'New Delhi, Delhi, India',
    top     :'49.5%',
    left    :'69.5%',
  },
  {
    location:'London, United Kingdom',
    top     :'30%',
    left    :'46.5%',
  },
  {
    location:'Quezon City, Philippines',
    top     :'55%',
    left    :'81.5%',
  },
  {
    location:'Baja California, Mexico',
    top     :'49.5%',
    left    :'16.5%',
  },
  {
    location:'Jacksonville, Florida',
    top     :'46%',
    left    :'24.5%',
  },
  {
    location:'Chicago, Illinois',
    top     :'40%',
    left    :'22.5%',
  },
  {
    location:'Saint Louis, Missouri',
    top     :'43%',
    left    :'21.5%',
  },
  {
    location:'Newnan, Georgia',
    top     :'44%',
    left    :'23.5%',
  },
  {
    location:'Battle Creek, Michigan',
    top     :'39%',
    left    :'24%',
  },
  {
    location:'La Cruces, New Mexico',
    top     :'44.5%',
    left    :'17.5%',
  },
  {
    location:'Norristown, Pennsylvania',
    top     :'40%',
    left    :'27%',
  },
  {
    location:'Hayward, California',
    top     :'41%',
    left    :'13.5%',
  },
  {
    location:'Wichita, Kansas',
    top     :'45%',
    left    :'20%',
  },
  {
    location:'Saint Louis, Missouri',
    top     :'43%',
    left    :'21.5%',
  },
  {
    location:'Willis, Texas',
    top     :'48%',
    left    :'20.5%',
  },
  {
    location:'Van Nuys, California',
    top     :'43%',
    left    :'14%',
  },
  {
    location:'Henrietta, New York',
    top     :'39%',
    left    :'26.5%',
  },
  {
    location:'Roguemont, North Carolina',
    top     :'42%',
    left    :'25.5%',
  },
  {
    location:'Lincoln, Nebraska',
    top     :'43%',
    left    :'20.5%',
  },
  {
    location:'Morgantown, West Virginia',
    top     :'40%',
    left    :'25%',
  },
  {
    location:'La Trinidad, Philippines',
    top     :'56%',
    left    :'82.5%',
  },
  {
    location:'Tagaytay, Philippines',
    top     :'55%',
    left    :'82.5%',
  },
  {
    location:'Lumban, Philippines',
    top     :'55.5%',
    left    :'82.5%',
  },
  {
    location:'Calamba, Philippines',
    top     :'55%',
    left    :'83%',
  },
  {
    location:'Caloocan, Philippines',
    top     :'55%',
    left    :'81.5%',
  },
  {
    location:'Cainta, Philippines',
    top     :'55.5%',
    left    :'81.5%',
  },
  {
    location:'San Pedro, Philippines',
    top     :'55%',
    left    :'83.5%',
  },
  {
    location:'Marikina, Philippines',
    top     :'54%',
    left    :'81.5%',
  },
  {
    location:'Makati, Philippines',
    top     :'56%',
    left    :'81.5%',
  },
  {
    location:'Antipolo, Philippines',
    top     :'54%',
    left    :'81%',
  },
]
